module.exports = "<div gw-loader=\"submissionLoadPromise\"></div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/quoteandbind/common/views/quote-entry.html
// module id = 492
// module chunks = 0